module.exports = __webpack_public_path__ + "static/img/download-1.7d65882c.jpeg";